<script lang="ts">
    import { Col } from "sveltestrap";
    import { HoverRating } from "../../../utils/Constant/Constant";
    import Card from "../../Core/Card.svelte";
    import {Rating} from 'svelte-stars-hover-rating';
    let rate:any=null

</script>
<Col md="6">
    <Card cardHeaderprops="pb-0" headerTitle={HoverRating} >
      <div slot="contentbody">
        <Rating bind:rating={rate} />
      </div>
    </Card>
</Col>